import className from 'classnames/bind';
import { IconButton } from '@components';
import ArrowRight from "@assets/svg/arrow-right.svg";

import styles from './QueryPagination.module.scss';
const cx = className.bind(styles);

interface QueryPaginationProps {
  onPageChange: (page: number) => void;
  currentPage: number;
  totalCount: number;
  perPage: number;
  size?: "medium" | "small";
  className?: string;
}

export default function QueryPagination(props: QueryPaginationProps) {
  const { onPageChange, currentPage, totalCount, perPage, className, size } = props;
  const totalPages = Math.ceil(totalCount / perPage);

  const getPageNumbers = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage < 3) {
      return [1, 2, 3, '...', totalPages];
    }
    
    if (currentPage === 3) {
      return [1, 2, 3, 4, '...', totalPages];
    }
    if (currentPage >= totalPages - 2) {
      return [1, '...', totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  const pageNumbers = getPageNumbers();

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (page: number | string) => {
    if (typeof page === 'number') {
      onPageChange(page);
    }
  };
  return (
    <div className={cx(["query-pagination", className])}>
      <div className={cx("query-pagination__buttons")}>
        <IconButton
          size={size}
          icon={ArrowRight}
          className={cx("prev-button")}
          onClick={handlePrevious}
          disabled={currentPage === 1}
        />
        <ul className={cx("page-numbers")}>
          {pageNumbers.map((page, index) => (
            <li key={index} className={cx("page-item")}>
              {page === '...' ? (
                <span className={cx(["ellipsis", "cta"])}>...</span>
              ) : (
                <button
                  className={cx(["page-link", "cta", { active: page === currentPage }])}
                  onClick={() => handlePageClick(page)}
                >
                  {page}
                </button>
              )}
            </li>
          ))}
        </ul>
        <IconButton
          size={size}
          icon={ArrowRight}
          className={cx("next-button")}
          onClick={handleNext}
          disabled={currentPage === totalPages}
        />
      </div>
    </div>
  )
}